import { defineComponent as n, createElementBlock as t, openBlock as o, normalizeProps as l, guardReactiveProps as i, unref as c, createCommentVNode as m, renderSlot as r } from "vue";
import { useBindCx as a } from "@scalar/components";
const u = {
  key: 0,
  class: "request-response-header bg-b-1 -mb-1/2 sticky top-0 z-1 flex min-h-11 items-center border-b px-2.5 text-base font-medium xl:rounded-none"
}, b = /* @__PURE__ */ n({
  inheritAttrs: !1,
  __name: "ViewLayoutSection",
  setup(d) {
    const { cx: s } = a();
    return (e, f) => (o(), t("section", l(i(
      c(s)("xl:custom-scroll bg-b-1 flex flex-1 flex-col xl:h-full xl:min-w-0")
    )), [
      e.$slots.title ? (o(), t("div", u, [
        r(e.$slots, "title")
      ])) : m("", !0),
      r(e.$slots, "default")
    ], 16));
  }
});
export {
  b as default
};
